import styled from "styled-components";
import { Button as AntButton, Modal as AntModal } from "antd";
import { InviteLinkTopBg } from '@assets';

export const InviteLinkContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 100%;

	background-color: #fff;
`;


export const InviteLinkTitle = styled.p`
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 32px; /* 145.455% */

	@media screen and (max-width: 375px) {
		font-size: 18px;
	}
`;

export const CreateLinkButton = styled(AntButton)`
	padding: 0;
	margin: 5px auto 20px;
	box-sizing: border-box;
	width: calc(100% - 60px) !important;
	height: 55px;
	border-radius: 8px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);

	color: #2A2A2A;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */

	:hover {
		background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%) !important;
		color: #2A2A2A !important;
	}

	/* svg {
		width: 40px !important;
		height: 40px !important;
	} */
`;

export const TermsAndConditionsContainer = styled.div`
	padding: 16px;
	margin: 0 auto 40px;
	box-sizing: border-box;
	width: calc(100% - 64px);

	border-radius: 20px;
	background: #FFF4D2;
`;

export const InviteLinkTerm = styled.p`
	text-align: left;
	color: #2A2A2A;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */
`;

export const InviteLinkTerms = styled.span`
	padding-left: 16px;
	color: #2A2A2A;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */
`;

export const CopyTitle = styled.p`
	margin-bottom: 10px;
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 32px; /* 145.455% */
`;

export const CopyLink = styled.a`
	display: block;

	color: #2A2A2A;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 26px; /* 162.5% */

	:hover {
		color: #2A2A2A;
		text-decoration: underline;
	}
`;

export const CreateLinkWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 8px;
	margin-top: -10px;

	width: 100%;
`;

export const ButtonWrapper = styled.div`
	display:flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	width: 100%;
	gap: 4px;

	margin: 0 !important;
`;

export const ButtonDiv = styled(AntButton)`
	height: 50px;
	width: 50%;
`;

export const Modal = styled(AntModal)`
	.ant-modal-content {
		border: none !important;
		padding: 95px 0 0 0 !important;
		margin: 0 !important;
	}
	.ant-modal-body {
		padding: 0 16px 16px 16px !important;
	}
`;

export const TitleLinkWrapper = styled.div`
	padding: 0px 16px 16px;
`;


export const TopImg = styled.div`
	height: 400px;
	width: 100% !important;
	background-image: url(${InviteLinkTopBg});
	background-size: cover;
	background-position: bottom;
	background-repeat: no-repeat;

	@media screen and (max-width: 420px) {
		height: 350px;
	}

	@media screen and (max-width: 375px) {
		height: 320px;
	}
`

export const Desc = styled.p`
	color: #2A2A2A;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 26px; /* 162.5% */

	width: calc(100% - 60px);
	margin-top: 16px;
`